import { Trans } from '@lingui/macro'
import { Alert, AlertTitle } from '@mui/material'

export const ExpressionOfInterestBanner = ({
  unresolvedCaseExists = false,
  approvedCaseExists = false
}) => {
  return (
    <Alert severity="info">
      <AlertTitle>
        {unresolvedCaseExists ? (
          <Trans>EXPRESSION_OF_INTEREST_IN_PROGRESS_HELPTEXT</Trans>
        ) : approvedCaseExists ? (
          <Trans>EXPRESSION_OF_INTEREST_APPROVED_HELPTEXT</Trans>
        ) : (
          <Trans>EXPRESSION_OF_INTEREST_HELPTEXT</Trans>
        )}
      </AlertTitle>
    </Alert>
  )
}
